export default "../static/img/fa7ea3f3be958a2a7e5e243889ee1726.jpg";